import { Delete } from 'ui/icons';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { useTranslation } from 'modules/domains/list';
import { useModalContext } from 'utils/contexts/modal';
import { List, ListIndexModalState } from '../../../types';
import { useListsContext } from '../../../contexts';

export const useDeleteListsButton = (list: List) => {
  const { t } = useTranslation();
  const { showModal } = useModalContext<ListIndexModalState>();
  const { setListsToDelete } = useListsContext();

  // TODO: replace with deleteListFolderAndContents once bulk actions is implemented
  return {
    as: AllowedActionMenuElements.Button,
    content: (
      <>
        <Delete height={16} width={16} />
        <span>{t(`indexPage.table.overflowMenu.delete`)}</span>
      </>
    ),
    id: 'list-delete',
    onClick: () => {
      setListsToDelete([list]);
      showModal(ListIndexModalState.confirmDelete);
    },
  };
};
